import { StoreService } from '@se-po/se-household-setup-data-access-store'
import { AccountInfoFormSubmitService } from '@se-po/se-household-setup-feature-account-info'
import { PasswordFormSubmitter } from '@se-po/se-household-setup-feature-create-password'
import { MatchFormSubmitService } from '@se-po/se-household-setup-feature-match'
import { VerificationSubmitter } from '@se-po/se-household-setup-feature-verification'
import { AnalyticsService } from '@se-po/shared-data-access-services'
import { AnalyticsStub } from '@test-util'

import { DocsAccountStore } from './docs-account-store.service'
import { DocsAccountSubmitter } from './docs-account-submitter.service'
import { DocsMatchSubmitter } from './docs-match-submitter.service'
import { DocsPasswordSubmitter } from './docs-password-submitter.service'
import { DocsVerificationSubmitter } from './docs-verification-submitter.service'

export const PROVIDERS = [
  {
    provide: AnalyticsService,
    useClass: AnalyticsStub,
  },
  {
    provide: AccountInfoFormSubmitService,
    useClass: DocsAccountSubmitter,
  },
  {
    provide: MatchFormSubmitService,
    useClass: DocsMatchSubmitter,
  },
  {
    provide: PasswordFormSubmitter,
    useClass: DocsPasswordSubmitter,
  },
  {
    provide: StoreService,
    useClass: DocsAccountStore,
  },
  {
    provide: VerificationSubmitter,
    useClass: DocsVerificationSubmitter,
  }
]
